<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Progressive Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-smart-offer-bundle-progressive-type :model.sync="model.type" label="Type"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
          <r-reward-panel :model.sync="model.rewardOnMerge" title="Reward on merge"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" md="4" sm="4">
            <r-currency-kind-dropdown :model.sync="model.currency" />
          </v-col>
          <v-col cols="12" md="4" sm="4" v-if="groups_product_premium.length > 0">
            <r-product-dropdown :model.sync="model.product" :groups="groups_product_premium" label="Product"/>
          </v-col>
        </v-row>
        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-reward-bunch-panel :model.sync="model.reward" title="Rewards" label="Reward" :points="true"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundleProgressive} from "@/modules/redactor/models/smart-offer/bundle-progressive/SmartOfferBundleProgressive";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RSmartOfferBundleProgressiveType from "@/modules/redactor/views/smart-offer/bundle-progressive/r-smart-offer-bundle-progressive-type.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";


export default {
  name: "r-smart-offer-bundle-progressive",
  components: {
    RRewardPanel,
    RRewardBunchPanel,
    RSmartOfferBundleProgressiveType,
    RProductDropdown,
    RCurrencyKindDropdown,
    RGuardMoneyPanel,
    RGuardPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleProgressive(),
    rules: ViewRules.READONLY,
  }),
    computed: {
        type_code() {
            return this.model.type ? this.model.type.id : 0
        },
        groups_product_premium() {
            if (this.type_code === 1) {
                return [ProductGroupKind.SMART_OFFERS];
            }/* else if (this.type_code === 3) {
                return [ProductGroupKind.SMART_OFFERS];
            } else if (this.type_code === 4) {
                return [ProductGroupKind.SMART_OFFERS];
            }*/ else {
                return [];
            }
        },
    },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleProgressive();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
